webpackJsonp([115125836411219],{

/***/ 1442:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"FulfillmentSourceInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"isExternal","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-fulfillment-source-input-083a9c5e2e32665753c0.js